import { render, staticRenderFns } from "./StepSpectators.vue?vue&type=template&id=279c5b10&lang=html&"
import script from "./StepSpectators.vue?vue&type=script&lang=js&"
export * from "./StepSpectators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports